import React, { useState } from "react";

function FlatLoginButton({ style, children, onClick, title }) {
const [hover, setHover] = useState(false);
const [focus, setFocus] = useState(false);
const [kbd, setKbd]   = useState(false);

  return (
    <button
      onClick={onClick}
      title={title}
      onPointerEnter={() => setHover(true)}
      onPointerLeave={() => setHover(false)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      onKeyDown={(e) => {
 const k = e.key;
  if (k === "Tab" || k === "Shift" || k.startsWith("Arrow")) setKbd(true);
}}
onPointerDown={() => setKbd(false)}
      style={{
        all: "unset", appearance: "none", WebkitAppearance: "none",
        display: "inline-flex", alignItems: "center", gap: 5,
        height: 22, padding: "0 4px", boxSizing: "border-box",
        background: "transparent",                // flat
        border: `1px solid ${hover ? "rgba(255,255,255,.35)" : "rgba(255,255,255,.18)"}`,
        borderRadius: 3,
        color: "#e6edf3", fontSize: "var(--fs-12, 12px)" , lineHeight: 1, cursor: "pointer",
        outline: kbd && focus ? "1px dashed rgba(156,176,230,.95)" : "none",
        outlineOffset: kbd && focus ? 1 : 0,
        ...style,
      }}
    >
      {children}
    </button>
  );
}




// --- oben in AccountCapsule.jsx ---
function LoginIcon({ size = 14, color = "currentColor", doorW = 0, arrowW = 0 }) {
  return (
    <svg width={size} height={size} viewBox="0 2 25 28" fill="#FF8800" style={{ display: "block", flexShrink:0 }}>
      <path d="M12.219 26.156h6.094c1.156 0 2.125-0.406 2.875-1.188 0.75-0.75 1.219-1.75 1.219-2.875v-12.219c0-1.125-0.469-2.125-1.219-2.875s-1.75-1.188-2.875-1.188h-6.094v2.563h6.094c0.875 0 1.531 0.656 1.531 1.5v12.219c0 0.844-0.656 1.531-1.531 1.531h-6.094v2.531zM0 13.563v4.875c0 0.563 0.469 1.031 1.031 1.031h5.688v3.844c0 0.344 0.156 0.625 0.469 0.781 0.125 0.031 0.281 0.031 0.344 0.031 0.219 0 0.406-0.063 0.563-0.219l7.344-7.344c0.281-0.281 0.25-0.844 0-1.156l-7.344-7.313c-0.25-0.25-0.563-0.281-0.906-0.188-0.313 0.156-0.469 0.406-0.469 0.75v3.875h-5.688c-0.563 0-1.031 0.469-1.031 1.031z"
            stroke={color} strokeWidth={doorW} strokeLinecap="round" strokeLinejoin="round"
            vectorEffect="non-scaling-stroke" />
     
    </svg>
  );
}


export default function AccountCapsule({
  avatarUrl = null,
  displayName = "Gast",
  statusText = "Nicht angemeldet",
  statusText2 = "Rank: Admin", 
  onLogin = () => {},
}) {
  const initials =
    (displayName || "")
      .trim()
      .split(/\s+/)
      .map(s => s[0]?.toUpperCase())
      .join("")
      .slice(0, 2) || "LT";

  return (
    <section
      style={{
        borderRadius: 12,
        background: "rgba(10,12,18,.20)",
        border: "1px solid rgba(195,208,218,.50)",
        padding: "6px 10px 20px ",
        boxSizing: "border-box",
        color: "#e6edf3",
      }}
    >
      {/* HEAD: Avatar | Name/Status | Button */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "32px 1fr auto",
          gridTemplateRows: "38px",      // Zeile exakt 32px
          columnGap: 8,
          alignItems: "start",
          alignContent: "start",
          minWidth: 0,
        }}
      >
        {/* Avatar */}
        <div
          style={{
            width: 34, height: 34, borderRadius: 5, overflow: "hidden",
            border: "1px solid rgba(255,255,255,.60)", background: "rgba(0,0,0,.25)",
            display: "grid", placeItems: "center", userSelect: "none",
          }}
          aria-label="Avatar"
        >
          {avatarUrl ? (
            <img src={avatarUrl} alt="" style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }}/>
          ) : (
            <span style={{ fontWeight: 700, fontSize: 20, color: "#8FA8E8" }}>{initials}</span>
          )}
        </div>

        {/* Name + Status */}
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: "var(--fs-14, 14px)" , lineHeight: 1.1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {displayName}
          </div>
          <div style={{ fontSize: 14, lineHeight: 1.1, color: "rgba(230,237,243,.75)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {statusText}
            <div style={{ fontSize: 14, lineHeight: 1.1, color: "rgba(230,237,243,.75)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {statusText2}
            </div>  
          </div>
        </div>

        {/* Login-Button – HARD RESET */}
        <FlatLoginButton
  onClick={onLogin}
  title="Anmelden"
  style={{ gridColumn: 3, gridRow: 1, justifySelf: "end", alignSelf: "start" }}
>
  <span style={{ whiteSpace: "nowrap", transform: "translateY(0.0px)" }}>
    Login
  </span>
  <LoginIcon
    size={14}
    color="orange"
    // Icon fix, damit es nicht zusammenschrumpft:
    style={{ display: "block", flexShrink: 0 }}
  />
</FlatLoginButton>
      </div>
    </section>
  );
}
